import ListItem from "components/atoms/ListItem"
import HStack from "components/atoms/stack/HStack"
import VStack from 'components/atoms/stack/VStack'
import ThemedBlock from 'components/atoms/ThemedBlock'
import ThemedList from 'components/atoms/ThemedList'
import ListItemCredit from "components/molecules/ListItemCredit"
import TimeslotIcon from 'components/molecules/TimeslotIcon'
import _ from 'lodash'
import React, { useMemo, useState } from 'react'
import { StyleSheet, View } from 'react-native'
import { useSelector } from 'react-redux'
import CreditManageModal from "scenes/management/employees/components/employee/modals/creditManageModal"
import { dataConstants } from 'services/redux/data/constants'
import Button from "theme/Button"
import i18n from 'utils/i18n'
import Translate from 'utils/translate'

const EmployeeCredits = ({ employee, reload }) => {
	
	const [ modalCredit, setModalCredit ] = useState( null )

	const dataFiltered = useMemo(() => {
		return _.filter( employee?.credit_amounts, ( item ) => {
			return item.amount_unused > 0 || item.credit_bundle_available_for === 'yes';
		});
	}, [ employee ])

	const renderItem = ({ item, index }) => {

		return (
			<ListItemCredit
				item={ item }
				accessoryRight={(
					<HStack>
						<Button
							onPress={ setModalCredit.bind( this, item ) }>

							{ i18n.t( 'management:pages.employee.credits.button_add_remove' ) }
						</Button>
					</HStack>
				)}
			/>
		)
	}
	
	return (
		<VStack>
			<VStack>
				<ThemedBlock 
					shadow>
				
					<ThemedList
						data={ dataFiltered }
						renderItem={ renderItem.bind( this ) }
						scrollEnabled={ false }
					/>
				</ThemedBlock>
			</VStack>

			{/* Modals */}
			{ modalCredit !== null && (
				<CreditManageModal 
					employee={ employee }
					item={ modalCredit }
					onClose={ setModalCredit.bind( this, null ) }
					onConfirm={ () => {
						reload();
						setModalCredit( null );
					}}
				/>
			)}
		</VStack>
	)
}

const styles = StyleSheet.create({
	iconContainer: {
		width: 40,
		height: 40,
	},
	iconInner: {
		transform: [ {
			scale: 0.6
		} ],
	}
})

export default EmployeeCredits
